import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.reveal');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-dark-bg text-white min-h-screen flex flex-col antialiased overflow-x-hidden">
      <Header variant="landing" />

      <main className="flex-grow flex flex-col items-center justify-center px-6 text-center py-20">
        <div className="max-w-4xl mx-auto space-y-8 reveal">
          <h1 className="text-5xl md:text-8xl font-bold tracking-tight text-white leading-[1.05]">
            Get Your Project Built
          </h1>
          <p className="text-lg md:text-2xl text-white max-w-2xl mx-auto font-light opacity-90 reveal reveal-delay-1">
            Custom academic and software projects tailored to your requirements.
          </p>
          <div className="pt-6 reveal reveal-delay-2">
            <button
              onClick={() => navigate('/start')}
              className="bg-white text-black px-10 py-5 rounded-sm text-base font-bold tracking-wider hover:bg-gray-200 transition-all uppercase active:scale-95"
            >
              Start Project
            </button>
          </div>
        </div>
      </main>

      <section className="w-full max-w-[1000px] mx-auto pb-32 px-6 reveal">
        <div className="border-t border-thin-divider pt-16">
          <h4 className="text-muted-gray text-xs font-bold uppercase tracking-[0.3em] mb-16 text-center reveal-delay-1">Expertise</h4>
          <div className="grid grid-cols-1 md:grid-cols-4 items-center">
            <div className="flex items-center justify-center py-6 border-b md:border-b-0 md:border-r border-thin-divider reveal reveal-delay-1">
              <span className="text-sm font-medium text-white tracking-wide">Web Projects</span>
            </div>
            <div className="flex items-center justify-center py-6 border-b md:border-b-0 md:border-r border-thin-divider reveal reveal-delay-2">
              <span className="text-sm font-medium text-white tracking-wide">AI / ML</span>
            </div>
            <div className="flex items-center justify-center py-6 border-b md:border-b-0 md:border-r border-thin-divider reveal reveal-delay-3">
              <span className="text-sm font-medium text-white tracking-wide">Deep Tech</span>
            </div>
            <div className="flex items-center justify-center py-6 reveal reveal-delay-3">
              <span className="text-sm font-medium text-white tracking-wide">Final-Year Projects</span>
            </div>
          </div>
        </div>
      </section>


      <Footer variant="landing" />
    </div>
  );
};

export default LandingPage;
